import 'quill'

export interface Config {
    container: string;
    unit: 'word'|'char';
    max: number;
}

export interface QuillInstance {
    on: any;
    getText(): string;
    getSemanticHTML(): string;
}

export default class Counter {
    quill: QuillInstance;
    options: Config;

    constructor(quill, options) {
        this.quill = quill;
        this.options = options;

        const container = document.querySelector(this.options.container);

        this.quill.on('editor-change', () => {
            const length = this.calculate();

            container.innerHTML = length + '/' + this.options.max;
        })
    }

    calculate() {
        const text = this.quill.getText().trim();
        if (this.options.unit === 'word') {
            return !text ? 0 : text.split(/\s+/).length;
        }
        return text.length;
    }
}
